import { useEffect, useState } from "react";
//Redux
import { useSelector } from "react-redux";

const clampPercentage = (value) => {
  const number = Number(value || 0);

  if (number < 0) return 0;
  if (number > 100) return 100;

  return number;
};

function MetricCard({
  card,
  // machineUtilizationData,
  // operatorUtilization,
  filters,
  loading = false,
  isRefreshing = false,
  selectedCardNameExecute,
}) {
  const appConfig = useSelector(
    (state) => state?.common?.data?.dashboardControl,
  ); // User Details from Store
  const percentage = clampPercentage(card.percentage);
  const [animatedPercentage, setAnimatedPercentage] = useState(0);

  // const isMachineCard = card.dataType === "machine";
  // const isOperatorCard = card.dataType === "operator";

  // const isCardDataMissing =
  //   (isMachineCard && !machineUtilizationData) ||
  //   (isOperatorCard && !operatorUtilization);

  const isDataLoading = loading || isRefreshing;

  useEffect(() => {
    if (isDataLoading) {
      setAnimatedPercentage(0);
      return;
    }

    const timer = setTimeout(() => {
      setAnimatedPercentage(percentage);
    }, 120);

    return () => clearTimeout(timer);
  }, [percentage, isDataLoading]);

  const renderCardTitle = () => {
    if (isDataLoading) {
      return (
        <span className="metric-title-loading">
          {isRefreshing ? "Refreshing..." : "Loading..."}
        </span>
      );
    }

    if (!card.dataType) {
      return card.title;
    }

    const handleSelectedName = () => {
      if (typeof selectedCardNameExecute === "function") {
        selectedCardNameExecute(card.dataType);
      }
    };

    return card.dataType === "PRODUCTION" || appConfig?.machine_operator_dashboard ? (
      <button
        type="button"
        className="metric-card-link"
        onClick={handleSelectedName}
      >
        {card.title}
      </button>
    ) : (
      card.title
    );
  };

  return (
    <>
      <style>
        {`
          .metric-card-link {
            padding: 0;
            border: none;
            background: transparent;
            color: inherit;
            font: inherit;
            font-weight: inherit;
            text-align: left;
            cursor: pointer;
            color: #105ec4;
          }

          .metric-card-link:hover {
            color: #053c83;
            text-decoration: underline;
          }

          .metric-title-loading {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            min-height: 24px;
            color: #64748b;
            font-size: 14px;
            font-weight: 600;
          }

          .metric-loading-spinner {
            width: 16px;
            height: 16px;
            display: inline-block;
            flex-shrink: 0;
            border: 2px solid #dbe3ee;
            border-top-color: #053c83;
            border-radius: 50%;
            animation: metricSpinnerRotate 0.75s linear infinite;
          }

          .compact-metric-card.is-loading {
            pointer-events: none;
            opacity: 0.82;
          }

          .compact-metric-card.is-loading .metric-icon-box {
            animation: metricLoadingPulse 1.1s ease-in-out infinite;
          }

          .metric-value-loading {
            min-height: 34px;
            display: flex;
            align-items: center;
          }

          @keyframes metricSpinnerRotate {
            to {
              transform: rotate(360deg);
            }
          }

          @keyframes metricLoadingPulse {
            0%,
            100% {
              opacity: 0.55;
              transform: scale(0.96);
            }

            50% {
              opacity: 1;
              transform: scale(1.04);
            }
          }
        `}
      </style>

      <article
        className={`compact-metric-card ${card.tone} ${
          isDataLoading ? "is-loading" : ""
        }`}
        aria-busy={isDataLoading}
      >
        <div className="card-main-row">
          <div className="metric-icon-box">
            <span>{card.icon}</span>
          </div>

          <div className="metric-content">
            <h3>{renderCardTitle()}</h3>

            <div className="metric-value">
              {isDataLoading ? (
                <div className="metric-value-loading">
                  <span className="metric-loading-spinner" />
                </div>
              ) : (
                <>
                  {card?.key === "machine" ? (
                    <strong>
                      {card.info? (
                        card.value
                      ) : (
                        <span className="metric-loading-spinner" />
                      )}
                    </strong>
                  ) : (
                    <strong>{card.value}</strong>
                  )}

                  {card.unit && (
                    <span>
                      {card.unit}{" "}
                      {card?.info ? (
                        <i
                          className="bi bi-info-circle"
                          title={card?.info}
                          style={{
                            marginLeft: "12px",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                        ></i>
                      ) : (
                        ""
                      )}
                    </span>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="card-bottom-row">
          <p className={card.danger ? "danger-text" : ""}>
            {isDataLoading
              ? isRefreshing
                ? "Updating dashboard data..."
                : "Fetching dashboard data..."
              : card.label}
          </p>
        </div>

        <div className="mini-progress-row">
          <div className="mini-progress-track">
            <div
              className="mini-progress-fill"
              style={{
                width: isDataLoading ? "0%" : `${animatedPercentage}%`,
              }}
            />
          </div>

          <span className="mini-progress-value">
            {isDataLoading
              ? "--"
              : `${Number(card.percentage || 0).toFixed(
                  Number(card.percentage || 0) % 1 === 0 ? 0 : 1,
                )}%`}
          </span>
        </div>
      </article>
    </>
  );
}

export default MetricCard;
